import { roleGuarded } from '@/components/shell/RoleState';
import { KnowledgeTab } from '@/features/ai/KnowledgeTab';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/ai/knowledge')({
  staticData: { roles: ['owner'] },
  component: roleGuarded(KnowledgeTab),
});
